<template>
  <section class="pdp">
    <div v-if="b2bGuardProductDisplay">
      <div class="pdp__main" :style="background">
        <div class="pdp__main-width-container" :style="containerStyles">
          <breadcrumbs v-if="$mq === 'mobile'" :collection="collection" :product="product" />
          <product-gallery v-bind="$props" v-model="variant"></product-gallery>
          <product-form v-bind="$props" v-model="variant" :prices="prices" :display-vendor="displayVendor"
            :pseudo-variants="pseudoVariants"></product-form>
        </div>
      </div>

      <div class="pdp__video-slider-details" v-if="getVideos">
        <h1 class="pdp__video-heading">{{ customFields.video_section_title }}</h1>
        <div class="pdp__slider_container pdp__video_collections"
          style="position: relative;z-index: 3;margin: 0 auto;max-width: 1307px;">

          <div class="pdp__controls-container">
            <div class="arrows">
              <arrow-button primary left @click="slidePrev" label="Product Navigation Previous"
                class="button--arrow-primary button--left" :disabled="leftArrowDisabled" />
              <arrow-button primary right @click="slideNext" label="Product Navigation Next"
                class="button--arrow-primary button--right" :disabled="rightArrowDisabled" />
            </div>
          </div>

          <swiper :options="this.swiperOptions" :ref="`pdp_videoSwiper`" :space-between="50" @swiper="onSwiper"
            @slideChange="onSlideChange">
            <swiper-slide v-for="(video, index) in getVideos" :key="index">
              <div class="pdp__video-card">
                <div class="pdp__video-card__child">
                  <video :ref="'videoPlayer' + index" class="pdp__video-html5" :src="video.video_url" width="100%"
                    height="100%" controls></video>
                  <div class="video_overlay" :style="{
                    backgroundImage: `url(${video.cover_image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    height: '100%',
                    borderRadius: '20px',
                    opacity: videoClicked[index] ? '0' : '1',
                    transition: 'opacity 0.5s ease',
                  }" @click="playVideo(index)"></div>
                </div>
                <div class="pdp__video-card__text">
                  <p v-html="video.video_text"></p>
                </div>
              </div>
            </swiper-slide>

          </swiper>

        </div>
      </div>

      <div class="pdp__more-details">
        <product-more-details :custom-fields="customFields"></product-more-details>
      </div>

      <div class="pdp__three-column-info" v-if="$mq === 'mobile'">
        <div class="product-form__detail-icons-container" v-if="$mq === 'mobile'">
          <div class="product-form__detail-icons">
            <div class="product-form__detail-icon" v-for="(valueProp, i) in badgesWithTitle" :key="i">
              <img class="product-form__detail-icon-icon" :src="valueProp.icon">
              <span class="product-form__detail-icon-title"> {{ valueProp.title }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="pdp__custom-section-parent">
        <div v-html="customFields.custom_section"></div>
      </div>
      <div class="pdp__how-to-use">
        <product-how-to-use :custom-fields="customFields" />
      </div>
      <div class="pdp__skin-experience" v-if="customFields.skin_experience_active == 1">
        <product-skin-experience :custom-fields="customFields" />
      </div>
      <div class="pdp__custom-section2-parent">
        <div v-html="customFields.custom_section2"></div>
      </div>
      <div class="pdp__reviews pdp--side-padded-mobile container" id="pdp-reviews" v-if="!settings.hideReviews">
        <product-reviews v-bind="$props" :v-model="variant"></product-reviews>
      </div>
      <div class="pdp__product-recs" v-if="recommendedProducts.length">
        <featured-collection :enableSimpleTile="true" :enableSimpleTileCta="true" :featuredCollection="{
          shopAllBtn: 'Visitors also viewed',
          heading: 'You May Also Like',
          products: recommendedProducts,
          marginBottom: 0,
          enableCta: !!settings.overrideCollectionUrl,
          ctaLink: settings.overrideCollectionUrl,
          ctaLayout: 'link link--primary'
        }" />
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex';
import ProductGallery from './ProductGallery.vue'
import ProductForm from './ProductForm.vue'
import ProductBreadcrumbs from './ProductBreadcrumbs.vue'
import ProductMoreDetails from './ProductMoreDetails.vue'
import ProductReviews from './ProductReviews.vue'
import ProductHowToUse from './ProductHowToUse.vue';
import ProductThreeColumnInfo from './ProductThreeColumnInfo.vue';
import ProductSkinExperience from './ProductSkinExperience.vue';
import FeaturedCollection from '@/scripts/components/sections/FeaturedCollection.vue'
import AboutImageBannerBlock from '@/scripts/components/sections/AboutImageBannerBlock.vue'
import {
  isColorClass,
  sumVariantPrices,
  isHiddenProduct,
  imageSize
} from '@/scripts/helpers/util'
import ValueProps from '@/scripts/components/footer/FooterValueProps.vue'
import SuperCollectionLinear from '@/scripts/components/pages/SuperCollection/SuperCollectionLinear.vue'
import Breadcrumbs from '@/scripts/components/navigation/Breadcrumbs.vue';
import prop from 'lodash/property'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import Icon from '@/scripts/components/basic/Icon.vue'
import ArrowButton from '@/scripts/components/buttons/ArrowButton.vue'

export default {
  name: 'ProductDisplay',
  components: {
    swiper,
    swiperSlide,
    Icon,
    ProductGallery,
    ProductForm,
    ProductBreadcrumbs,
    ProductMoreDetails,
    ProductReviews,
    ProductHowToUse,
    ProductThreeColumnInfo,
    ProductSkinExperience,
    FeaturedCollection,
    AboutImageBannerBlock,
    ValueProps,
    SuperCollectionLinear,
    Breadcrumbs,
    ArrowButton
  },
  props: {
    collection: Object,
    product: Object,
    customFields: Object,
    settings: Object,
    magnetProduct: Object,
    productTileTextAlignment: String,
    displayVendor: Boolean,
    brand: Array,
  },
  data() {
    return {
      isWholesale: this.product.tags.includes('wholesale'),
      isB2B: window.bvaccel.b2b,
      variant: this.product.selected_or_first_available_variant
        ? this.product.variants.filter(
          variant =>
            variant.id === this.product.selected_or_first_available_variant.id
        )[0]
        : {},
      recommendedProducts: this.settings.overrideRelatedProducts || [],
      reviewSource: window.bvaccel && window.bvaccel.reviewSource,
      pseudoVariants: null,
      getVideos: [],
      selectedVideo: 0,
      videoClicked: {},
      swiperOptions: {
        slidesPerView: 4,
        autoplay: "500",
        spaceBetween: 24,
        grabCursor: true, // Changes cursor to grab when hovering over Swiper
        allowTouchMove: true,
        loop: true, // Enable infinite loop
        threshold: 50,
        iOSEdgeSwipeDetection: true,
        iOSEdgeSwipeThreshold: 100,
        touchRatio: 1,
        touchMoveStopPropagation: false,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 4,
            spaceBetween: 40
          }
        }
      },
    }
  },
  created() {
    this.identifyUpsell();
  },
  mounted() {

    if (!(this.isWholesale ? this.isB2B : true)) {
      window.location.href = '/404';
    }

    const { landing_page_settings } = this.customFields;
    const videoUrls = landing_page_settings && landing_page_settings[0]?.video_urls || null;
    this.getVideos = videoUrls;

    if (this.recommendedProducts.length <= 0) {
      // get recommended products
      axios
        .get(
          `/recommendations/products?section_id=recommended-products--json&product_id=${this.product.id}&limit=8`,
          { withCredentials: true }
        )
        .then(res => {
          // get json from inside recommended-section div and parse it.
          if (res && res.data && res.data.length) {
            const temp = document.createElement('div')
            temp.innerHTML = res.data
            const data = JSON.parse(temp.firstChild.innerText.trim())
            if (data.products instanceof Array) {
              this.recommendedProducts = data.products.filter(
                prod => prod.available && !isHiddenProduct(prod)
              )
            }
          }
        })
        .catch(e =>
          console.error('error fetching recommended products', e.message)
        )
    }

    // get "variant" products
    axios
      .get(
        `/collections/all/${this.product.variants[0].sku.split('-')[0]
        }?view=json`
      )
      .then(res => {
        this.pseudoVariants = res.data.products.map((item) => ({
          id: item.id,
          title: item.title,
          handle: item.handle,
          url: item.url,
          available: item.available,
          thumbnailImage: item.thumbnailImage ? item.thumbnailImage : item.images[0] && this.imageSize(item.images[0].src, '100x100')
        }))
      })
      .catch(err => {
        console.error('error fetching pseudo variants', err.message)
      })
  },
  methods: {
    imageSize,
    /**
     * @desc Prefer the scopedUpsell to the globalUpsell.
     */
    identifyUpsell() {
      const { globalUpsell, scopedUpsell } = this.product;
      const upsell = scopedUpsell || globalUpsell;
      if (!upsell) return;
      this.$store.dispatch('upsell/setUpsell', upsell);
    },
    slidePrev(index) {
      this.$refs.pdp_videoSwiper.swiper.slidePrev()
    },
    slideNext(index) {
      this.$refs.pdp_videoSwiper.swiper.slideNext()
    },
    playVideo(index) {
      const video = this.$refs['videoPlayer' + index][0];
      this.selectedVideo = index;
      this.$set(this.videoClicked, index, true);
      if (video) {
        if (video.paused) {
          video.play();  // Play the video if it's paused
        } else {
          video.pause();  // Pause the video if it's playing
        }
      }
    },
  },
  computed: {
    ...mapState({
      difference: ({ navbar }) => navbar.difference,
    }),
    background() {
      const { landing_page_settings } = this.customFields;
      const backgroundColorCode = landing_page_settings && landing_page_settings[0]?.background_color_code || 'white';
      return {
        background: backgroundColorCode
      };
    },

    containerStyles() {
      if (this.$mq !== 'mobile') return {}
      return {
        paddingTop: `${this.difference}px`,
      }
    },
    /** convert metafield client readable colors to class names  */
    transformedValuePropsSettings() {
      const transforms = [
        { key: 'backgroundColor', prefix: 'bg' },
        { key: 'borderColor', prefix: 'border' },
        { key: 'dividerColor', prefix: 'bg' },
        { key: 'textColor', prefix: 'color' }
      ]
      const newValues = {}
      for (const tran of transforms) {
        const value = this.settings.valueProps.settings[tran.key]
        if (!isColorClass(value)) {
          newValues[tran.key] =
            tran.prefix + '-' + this.$store.state.metafieldColorMap[value]
        }
      }

      return Object.assign(this.settings.valueProps.settings, newValues)
    },

    featuredCollectionsSettings() {
      return {
        heading: this.settings.featuredCollections.heading,
        headingColor: this.settings.featuredCollections.headingColor,
        backgroundColor: this.settings.featuredCollections.backgroundColor,
        linearArray: this.settings.featuredCollections.blocks
      }
    },
    prices() {
      const prices = sumVariantPrices(this.variant, this.selectedMagnetVariant)
      return prices
    },
    hideValueProps() {
      return (
        this.settings.valueProps.settings.hide ||
        !this.settings.valueProps.blocks
          .slice(0, 2)
          .every(prop('settings.icon'))
      )
    },
    badgesWithTitle() {
      let detailIconTitles = this.customFields.title ? this.customFields.title.split('|###|') : [];
      let detailIconIcons = this.customFields.icon ? this.customFields.icon.split('|###|') : [];
      return detailIconIcons.map((icon, i) => ({
        title: (detailIconTitles[i]) ? detailIconTitles[i] : '',
        icon: detailIconIcons[i]
      }));
    },
    bannerData() {
      const textColor = /light/i.test(this.customFields.banner_text_color)
        ? 'color-white'
        : 'color-black'
      const overlayColor = /light/i.test(this.customFields.banner_overlay_color)
        ? 'bg-white'
        : 'bg-black'
      const overlayOpacity = this.customFields.banner_overlay_opacity
        ? Math.round(parseInt(this.customFields.banner_overlay_opacity))
        : 0 // 1-9

      return {
        enableCta: false,
        ctaUrl: '',
        headingColor: textColor,
        heading: this.customFields.banner_header,
        subHeadingColor: textColor,
        subHeading: this.customFields.banner_subheading,
        copyColor: textColor,
        ctaLayout: null,
        ctaText: null,
        heading: this.customFields.banner_header,
        copy: this.customFields.banner_body_copy,
        overlayEnable: true,
        imageMobileEnable: true,
        overlayColor: overlayColor,
        overlayOpacity: overlayOpacity,
        mobileBgColor: 'bg-white',
        layoutVertical: 'middle',
        layoutHorizontal: 'center',
        imageMobile:
          this.customFields.banner_mobile_image ||
          this.customFields.banner_desktop_image,
        image: this.customFields.banner_desktop_image
      }
    },
    b2bGuardProductDisplay() {
      return this.isWholesale ? this.isB2B : true;
    },
  }
}
</script>

<style lang="scss" scoped>
.video_overlay {
  top: 0px;
  display: block;
  position: absolute;
  width: 100%;
  height: 75%;
  opacity: 1;
  background: transparent;
}


.pdp {
  @include mobile-only {
    margin-top: -54px;
  }

  &__video-heading {
    font-family: "Utopia Std";
    text-transform: none;
    font-size: 35px;
    font-weight: bolder;
  }

  &__video-vimeo-iframe {
    min-height: 35vw;

    @include mobile-only {
      min-height: 88vw;
    }
  }

  &__video-card {
    background-color: #fff;
    border-radius: 15px;
    border: 1px solid black;
    width: 300px;
    text-align: center;
    overflow: hidden;
    font-size: 16px;

    &__child {
      display: flex;
      position: relative;
      margin-bottom: 10px;
    }

    @include mobile-only {
      width: 213px;
    }

    &__text {
      margin: 0;
      font-family: "Utopia Std";
      font-weight: bold;
      font-size: 18px;
      color: #333;
      margin-bottom: 15px;
    }
  }

  &__controls-container {
    margin-bottom: 20px;
    display: flex;
    justify-content: right;

    .arrows {
      display: flex;
      flex-direction: row;
      cursor: pointer;
      line-height: 0;

      .arrow-next,
      .arrow-prev {
        svg {
          transition: stroke 150ms ease-in;
          stroke-width: 1px;
          stroke: transparent;
        }

        &:hover {
          svg {
            stroke-width: 1px;
            stroke: $color-black;
          }
        }
      }

      .arrow-prev {
        padding-right: 32px;
        transform: rotate(180deg);
      }

      .arrow-next {
        padding-left: 32px;
      }
    }
  }

  &__main {
    max-width: 100%;
    margin: 0 auto;
    padding-bottom: 48px;
    display: flow-root;
    background: #ecf2fa;

    @include mobile-only {
      padding-bottom: 0;
    }
  }

  .section-padded {
    padding-top: 0;
  }

  .margin-bottom {
    margin-bottom: 20px;

    @include tablet-up {
      margin-bottom: 56px;
    }
  }

  &__video-slider-details {
    text-align: center;
    margin-top: 20px;
  }

  &__main+* {

    // make sure the next section doesn't float up into the product form/gallery space
    clear: both;
  }

  &__main-width-container {
    max-width: 100%;
    margin: 0 auto;
    position: relative;
  }

  &--flex-row {
    display: flex;
    justify-content: space-between;
  }

  &__sku {
    margin-right: 16px;
    color: $color-off-black;
    display: inline-block;
  }

  &__tech-specs {
    @include tablet-up {
      padding-left: $grid-gutter;
      padding-right: $grid-gutter;
    }
  }

  @include mobile-only {
    .hero-banner__content * {
      color: $color-black !important;
    }
  }

  &__product-recs .container {
    padding: 0;
  }

  // Footer overrides
  /deep/ .footer-value-props-container,
  /deep/ .footer-value-props-container .footer-value-prop {
    border: none !important;
  }

  /deep/ .footer-value-prop__title {
    @include h6-tablet;
  }

  /deep/ .footer-value-prop__icon {
    max-width: 100px;
  }

  /deep/ .footer-value-prop__text {
    @include mobile-only {
      margin-bottom: 0;
    }
  }

  /deep/ .footer-value-prop__pagination .swiper-pagination-bullet:not(.swiper-pagination-bullet-active) {
    background: $color-grey;
  }

  /deep/ .footer-value-prop-heading {
    margin-bottom: 24px;
    @include h3-mobile;

    @include tablet-up {
      @include h4-tablet;
      margin-bottom: 48px;
    }
  }
}

.pdp {
  /deep/ .super-collection-linear__tile {
    max-width: 200px;
  }

  /deep/ .swiper-pagination-bullet.swiper-pagination-bullet-active {
    color: $color-brand-primary;
  }

  @include mobile-only {
    padding-bottom: 24px;
  }

  &--wrapper {
    @include mobile-only {
      padding-bottom: 24px;
    }
  }

  .hero__background {
    @include mobile-only {
      display: none;
    }

    bottom: 120px;
  }

  &>.container {
    margin-top: 24px;

    @include tablet-up {
      padding: 56px $grid-gutter;
    }
  }

  @include mobile-only {
    &--side-padded-mobile {
      margin-left: 15px;
      margin-right: 15px;
      width: calc(100% - 30px);
    }
  }

  @include tablet-up {
    &__main {
      padding: 0 0 56px;
      font-size: 0;
    }

    /deep/ .super-collection-linear__heading {
      margin-bottom: 40px;
    }

    &__accordions {
      width: 50%;
    }

    &__reviews {
      max-width: 1075px;
    }

    @include desktop-up {
      &__accordions {
        width: 36%;
        padding-left: 120px;
      }
    }

    &__sticky-container {
      position: relative;
    }
  }

  @include desktop-up {
    &__product-recs .controls-container {
      display: none !important;
    }
  }

  &custom-section-parent {
    text-align: center;
  }
}



/deep/ #BVRRContainer {
  padding-bottom: 56px;
}

@media screen and (min-width: 1400px) {
  .pdp--sidebar-active {
    .pdp__main .pdp__main-width-container {
      max-width: 1400px;
      padding-right: 240px;
      margin: 0 auto;
    }

    /deep/ .pdp__main .product-rec-sidebar {
      display: absolute;
      right: 0;
      top: 0;
      display: block;
    }

    /deep/ .pdp__main .product-form,
    /deep/ .pdp__main .product-details,
    /deep/ .pdp__main .pdp-gallery {
      width: 50%;
    }
  }
}

.product-form__detail-icons-container {
  margin-top: 10vw;
  margin-bottom: 10vw;
}


/* iPhone 12 Pro */
@media only screen and (min-device-width: 390px) and (max-device-width: 844px) and (-webkit-device-pixel-ratio: 3) {

  /* Your styles for iPhone 12 Pro */
  .pdp__video-card {
    width: 202px;
  }
}

/* iPhone 12 Pro Max */
@media only screen and (min-device-width: 428px) and (max-device-width: 926px) and (-webkit-device-pixel-ratio: 3) {

  /* Your styles for iPhone 12 Pro Max */
  .pdp__video-card {
    width: 213px;
  }
}

/* Samsung Galaxy S8 */
@media only screen and (min-device-width: 360px) and (max-device-width: 740px) and (-webkit-device-pixel-ratio: 4) {

  /* Your styles for Samsung Galaxy S8 */
  .pdp__video-card {
    width: 186px;
  }
}
</style>